import { GET_NOTIFICATIONS, DELETE_NOTIFICATIONS } from "../actions/types";
const initialState = {
  items: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        items: action.payload,
      };
    case DELETE_NOTIFICATIONS:
      return {
        ...state,
        items: state.items.filter((f) => f.id !== action.payload.id),
      };
    default:
      return state;
  }
}
